import { Tab, Tabs } from '@mui/material';
import { DashboardYearFilter } from '../components/DashboardYearFilter';
import { useStudentServiceData } from '../contexts';
import { useDashboardSchoolYear } from '../contexts/DashboardSchoolYearContext';
import { StudentServiceMetric } from '../types';

export const StudentServiceFilterControls = ({ showMetric = true }: { showMetric?: boolean }) => {
    const { filter, updateFilter, activeSchoolYear, metric, setMetric } = useStudentServiceData();
    const { schoolYears } = useDashboardSchoolYear();
    return <DashboardYearFilter idPrefix="student-service" years={filter.schoolYears} activeSchoolYear={activeSchoolYear}
        availableYears={schoolYears.map(schoolYear => schoolYear.id)}
        onApply={selectedSchoolYears => updateFilter({ schoolYears: selectedSchoolYears })}>
        {showMetric && <Tabs value={metric} onChange={(_, value: StudentServiceMetric) => setMetric(value)}>
            <Tab label="Participation Rate" value="participantRate" />
            <Tab label="Average Hours" value="averageHours" />
        </Tabs>}
    </DashboardYearFilter>;
};
